function sanitizeFromXML(text) {
  const sanitized = text.replace(/<\/?[^>]+(>|$)/g, '');
  return sanitized;
}

export default sanitizeFromXML;